import React from "react";

/**
 * Documentation: https://bulma-tagsinput.netlify.app/
 */
import BulmaTagsInput from '@creativebulma/bulma-tagsinput';

import { BaseComponent } from "shared/components";

/**
*
*
* @param choices list of choices
*/
function withBaseMultiSelect(choices) {
    return class extends BaseComponent {

        constructor(props) {
            super(props);

            this.defaultValue = [];
            if (props.value) {
                this.defaultValue = props.value;
            }

            this.state = {
                values: this.defaultValue,
                options: choices
            };

            this.resetState = this.resetState.bind(this);
            this.onChange = this.onChange.bind(this);
        }

        componentDidMount() {
            this.tagsInput = new BulmaTagsInput(this.refs.tagsinput, {});
            this.tagsInput.on('after.add', () => {
                this.onChange();
            });
            this.tagsInput.on('after.remove', () => {
                this.onChange();
            });

            const values = this.props.value || this.defaultValue;
            this.setState({ values });
        }

        componentDidUpdate(prevProps) {
            if (this.props.value !== prevProps.value) {
                const values = this.props.value;

                if (!values.length) {
                    this.tagsInput.flush();
                }

                this.setState({ values });
            }
        }

        onChange() {
            const values = this.tagsInput.value;
            this.setState({ values });

            if (this.props.onChange) {
                const name = this.props.name;
                this.props.onChange({
                    "target": { name, value: values }
                });
            }
        }

        resetState() {
            this.tagsInput.flush();
            this.setState({ values: [] });
        }

        render() {
            const { values, options } = this.state;
            const { id, label, name } = this.props;

            const dataPlaceholder = `Click & choose ${label.toLowerCase()}`;

            return (
                <div className="field">
                    <label className="label">{label}</label>
                    <div className="control">
                        <select ref="tagsinput" data-case-sensitive="false" name={name} id={id} value={values} multiple data-type="tags" data-placeholder={dataPlaceholder} >
                            {options.map((o) => (
                                <option key={o.value} value={o.value} selected={values.includes(o.value)}>{o.label}</option>
                            ))}
                        </select>
                    </div>
                </div>
            );
        }
    }
}

export default withBaseMultiSelect;
